module.exports = "{{skillName}}\n<div class=\"skill-bar-wrapper\" (whenInView)=\"triggerAnimation()\">\n  <div [style.width]=\"getSkillPercent()\" [@skillBarState]=\"{value: state, params: {'barWidth': skillWidth}}\" class=\"skill-bar-inner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/BenLeech/portfolio-website/portfolio-website/src/app/components/common/skill-bar/skill-bar.component.html
// module id = ../../../../../src/app/components/common/skill-bar/skill-bar.component.html
// module chunks = 1